import _ from 'lodash'

import { Order } from '../types'

export function getDeliveryName(order: Order): string {
  const { firstName, lastName } = order.delivery.contact.name

  return lastName + firstName
}

export function getAddress1(order: Order): string {
  const { region, locality } = order.delivery.contact.address

  return region + locality
}

export function getAddress2(order: Order): string {
  return order.delivery.contact.address.street
}

// TODO: Integrate 'subtotal' and 'subTotal' in all other places
export function getSubTotalPrice(order: Order): number {
  return _.get(order.chargeSheet.order, 'priceIncludingTax.price', 0)
}

export function hasFatalError(order: Order): boolean {
  return order.salesOrderStatus === 'payment-fatal-error'
}
